import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=748537de&"
import script from "./FileDropzone.vue?vue&type=script&lang=ts&"
export * from "./FileDropzone.vue?vue&type=script&lang=ts&"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports